import { checkIfGuid } from '@/functions/utility.js';

export default {
	// namespaced: true,
	state: {
		// BLOCK UNNCESSARY API CALLS
		blockGettingRoomData: false,
		blockGettingAreaData: false,

		changeCallback: false, //if function to call after a route change is complete {routeName, timestamp, callback}
	},
	getters: {
		// BLOCK UNNCESSARY API CALLS - when creating a space don't need to pull data again as get room data on response
		isGetRoomDataBlocked: state => state.blockGettingRoomData,
		isGetAreaDataBlocked: state => state.blockGettingAreaData,

		changeCallback: state => state.changeCallback,
	},
	mutations: {
		// BLOCK UNNCESSARY API CALLS
		BLOCK_GET_ROOM_DATA(state,data) {
			state.blockGettingRoomData = data
		},
		BLOCK_GET_AREA_DATA(state,data) {
			state.blockGettingAreaData = data
		},

		CHANGE_CALLBACK(state,data) {
			state.changeCallback = {...data, timestamp: Date.now()}
		},
	},
	actions: {
		async changeHandler({getters, rootGetters, commit, dispatch}, [fromRoute = null, toRoute = null]) {
			// get correct data from api on route change (both within app/pop state/url change) - on ENTER ROUTE
			let currentRoute = getters.routeData
			let areaIdUrl = currentRoute?.params?.areaId

			//if app is still loading - don't run before loadApp dispatch runs
			if(fromRoute && (rootGetters['loading/isLoading'] || !rootGetters['api/auth/isLoggedIn']) && currentRoute.name !== 'home') {
				// maintain redirect between auth pages until after authenticated and redirect is activated (ie for space invites redirect)
				if(fromRoute?.meta?.blockWhenAuthenticated && currentRoute?.meta?.blockWhenAuthenticated) {
					if(!currentRoute?.query?.redirectAfterAuth) {
						let redirectAfterAuth = fromRoute?.query?.redirectAfterAuth
						await dispatch('addQuery', {redirectAfterAuth})
					}
				}
				return console.log('stop change handler - still loading')
			}

			// clear state after leaving the previous route
			if(fromRoute) await dispatch('clearStateOnChange', [fromRoute, toRoute])

			if(currentRoute?.meta?.blockWhenAuthenticated && rootGetters['api/auth/authenticated']) {
				//redirect when authenticated going to auth pages - ie login/register
				await dispatch('goToHome')
				return console.log('stop change handler - go to home, block when authenticated')
			}

			let routeName = currentRoute.name
			let isDesktop = rootGetters['viewport/isDesktop']

			if(routeName === 'home') {
				console.log('home route')
				await dispatch('current_user/clearGuestState', null, {root: true}) //reset guest permissions before entering another area
				await dispatch('enterSwitchAreaPageHandler', null, {root: true})
				await dispatch('hideRoomLobby', null, {root: true})

				await dispatch('clearCurrentUsersRoom', null, {root: true})
				await dispatch('clearCurrentSpacePage', null, {root: true})
				await dispatch('clearCurrentAreaData', null, {root: true})
				await dispatch('clearLocationData', null, {root: true})
				await dispatch('clearCurrentUsersRoom', null, {root: true})
			} else if(routeName === 'area') {
				let roomParam = currentRoute.query?.room
				if(!roomParam && !fromRoute) dispatch('loading/unload', null, {root: true})
				else if(!roomParam && fromRoute?.name !== 'area') dispatch('guest/space/loadingLobby', null, {root: true})
				if(roomParam) {
					dispatch('guest/space/hideLobby', null, {root: true})
					if((fromRoute && fromRoute.name !== 'area') || !fromRoute) {
						console.log('enter area')
						await dispatch('enterAreaHandler', areaIdUrl, {root: true})
					}
					console.log('view room')
					await dispatch('viewRoom', roomParam, {root: true})
				} else if(!getters.isGetAreaDataBlocked && !rootGetters.enterJumpSpace) {
					let res = await dispatch('enterAreaHandlerOnRoomLoad', areaIdUrl, {root: true})
					if(res?.success) dispatch('guest/space/hideLobby', null, {root: true})
					else {
						dispatch('guest/space/showLobby', null, {root: true})
						console.log('ENTER AREA FAILED')
					}
				} else {
					console.log('enter space overview API not called due to a blocker - after leaving a room')
					commit('BLOCK_GET_AREA_DATA', false)
					dispatch('guest/space/hideLobby', null, {root: true})
				}
				if(rootGetters.getIfErrorEnteringArea) {
					dispatch('guest/space/showLobby', null, {root: true})
					//if error entering area, check if open space (else show login page)
					await dispatch('guest/space/handleAccessLobby', areaIdUrl, {root: true})
					dispatch('guest/space/loadedLobby', null, {root: true})
					dispatch('loading/load', null, {root: true})
					dispatch('updateEnterJumpSpace', null, {root: true})
					return //stop other actions failing if no access to area
				}
				dispatch('guest/space/loadedLobby', null, {root: true})
				dispatch('loading/load', null, {root: true})
				dispatch('updateEnterJumpSpace', null, {root: true})
				await dispatch('checkForActiveInvite', null, {root: true})
				if(isDesktop) {
					if (fromRoute?.name === 'room') {
						// We always want to open chat when entering a room
						await dispatch('sidebar/open', 'chats', {root: true})
					} else if(!roomParam) {
						if(fromRoute?.query?.room && rootGetters['sidebar/panelId'] !== 'info') return //clicking off view room on search - don't change to info after search
						// open the previous item otherwise
						else if (rootGetters['sidebar/prevPanelId']) {
							await dispatch('sidebar/openPrev', null, {root: true})
						} else {
							// no previous item - open the info panel
							await dispatch('sidebar/open', 'info', {root: true})
						}
					}
				}
			} else if(routeName === 'room') {
				let roomId = currentRoute?.params?.roomId
				if(fromRoute && fromRoute.name === toRoute.name && roomId === fromRoute.params.roomId) return //stop duplicate due to query params changing (jitsi preview)

				let isPassword = false
				if(roomId && roomId === rootGetters.getSpacePageId) {
					if(rootGetters.getSpacePasswordEnabled) isPassword = true
				}
				if(!fromRoute || !rootGetters.getCurrentAreaId || isPassword) { //show room lobby only on load or refresh
					//enter area happens on join room
					dispatch('showRoomLobbyHandler', null, {root: true})
					return
				}
				//server auto joins you into the correct area if accepting a room invite from a different area so don't need to worry about that here
				if(!getters.isGetRoomDataBlocked) {
					await dispatch('handleJoinRoom', roomId, {root: true})
				} else {
					console.log('enter room API not called due to a blocker - ie: after create space')
					commit('BLOCK_GET_ROOM_DATA', false)
				}
			} else if(routeName === 'manage-users' || routeName === 'customise') {
				dispatch('loading/unload', null, {root: true})
				let res = await dispatch('enterAreaHandler', areaIdUrl || rootGetters.getCurrentAreaId, {root: true})
				dispatch('loading/load', null, {root: true})
				if(res?.success && (!fromRoute || rootGetters.getCurrentAreaId !== areaIdUrl)) { //on load check for invites or if diff area (ie: accepting invite from another area)
					await dispatch('checkForActiveInvite', null, {root: true})
					await dispatch('analytics/enterSpace', 'direct', {root: true})
				}
			} else if(routeName === '404') {
				commit('loading/LOADING_404', true, {root: true})

				let url = currentRoute?.path
				let guids = url.split('/').filter(g => !!g)
				let validGuids = []
				if(guids.length) {
					guids.forEach(guid => {
						let ifGuid = checkIfGuid(guid)
						validGuids.push(ifGuid ? guid : false)
					})
				}
				//try to enter area if /areaGuid or enter area then room if /areaGuid/roomGuid
				if(validGuids[0] && validGuids[1]) { //enter area then room
					await dispatch('enterAreaHandlerOnRoomLoad', validGuids[0], {root: true})
					await dispatch('goToRoom', validGuids[1])
				} else if(validGuids[0]) { //enter area
					await dispatch('goToArea', validGuids[0])
				}
				//need timeout so dont show 404 before redirect (as a flash)
				setTimeout(() => commit('loading/LOADING_404', false, {root: true}), 1000)
			}

			//route change callback
			let routeCallback = getters.changeCallback
			if(routeCallback && routeCallback.routeName === currentRoute.name && routeCallback.timestamp > (Date.now() - 60000)) {
				routeCallback.callback()
				commit('CHANGE_CALLBACK', false)
			}
		},
		// clear state when routing away from a page
		async clearStateOnChange({commit,dispatch}, [from, to]) {
			// global changes -----------------------------
			await dispatch('search/clear', true, {root: true})
			dispatch('updateInviteFavicon', null, {root: true})
			commit('root/OPEN_MENU', false, {root: true})
			commit('setErrorEnteringArea', false, {root: true})
			// space specific changes ---------------------
			switch(from.name) {
				case 'home':
					await dispatch('clearUsersAreas', null, {root: true})
					break;
				case 'area':
					//maintain area state between pages for updating firebase, etc (dont clear if viewing rooms)
					if(to && to.name !== 'area') await dispatch('clearLocationData', null, {root: true})
					break;
				case 'room':
					await dispatch('clearCurrentSpacePage', null, {root: true})
					await dispatch('search/clearSpaceParticipants', null, {root: true})
					break;
				default:
					break;
			}
		},
	}
}
